module.exports = __webpack_public_path__ + "static/media/R2-drawing.dd1aa272.gif";